import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Route } from "../routes";
import StationsList from "../components/Stations/StationsList";
import Container from "../components/ui/Container/Container";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { useStationsService } from "../services/stations-service";
import { QueryKey } from "../services/query-keys";
import IStation from "../shared/IStation";
import { ErrorResponse } from "../custom-fetch";
import Button, { EButtonSize } from "../components/ui/Button/Button";

const StationsPage: React.FC = () => {
  const { fetchStations, refreshStations } = useStationsService();
  const queryClient = useQueryClient();

  const {
    data: stations,
    isPending,
    isError,
    error,
  } = useQuery<IStation[], ErrorResponse>({
    queryKey: [QueryKey.stations],
    queryFn: fetchStations,
    staleTime: 600000, // 10 minutes
  });

  const mutation = useMutation({
    mutationFn: refreshStations,
    onSuccess: (data) => {
      queryClient.setQueryData([QueryKey.stations], data);
    },
  });

  const refreshButton = (
    <Button 
      size={EButtonSize.X_SMALL}
      onClick={() => mutation.mutate()} 
      loading={mutation.isPending}
      style={{ fontSize: "14px", fontWeight: "normal", marginLeft: "auto" }}
    >
      Refresh from Wheels
    </Button>
  );

  return (
    <>
      <PageHeading backTo={Route.settings}>
        <span>Wheels Stations</span>
        {refreshButton}
      </PageHeading>
      <Container>
        <StationsList
          stations={stations}
          isPending={isPending}
          isError={isError}
          error={error}
        />
      </Container>
    </>
  );
};

export default StationsPage;
